import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Container,
    Typography,
    Box,
    Grid,
    List,
    ListItem,
    Card,
    CardMedia,
    Divider
} from "@mui/material";

function DataManagement() {
    const [datamanagement, setDatamanagement] = useState("");

    useEffect(() => {
        axios
            .get("/files/solutions/dataManagement.txt")
            .then((res) => setDatamanagement(res.data))
            .catch((err) => console.error(err));
    }, []);

    return (
        <Container maxWidth="lg" sx={{ py: 2 }}>
            <Typography align="center"
                gutterBottom
                sx={{
                    fontWeight: "bold",
                    color: "#030366",
                    mb: { xs: 4, sm: 5, md: 6 },
                    mt: 7,
                    fontSize: {
                        xs: "1.8rem", // mobile
                        sm: "2.2rem", // tablet
                        md: "2.8rem", // laptop
                        lg: "3rem",  // desktop
                    },
                }}
            >
                Data Management
            </Typography>

            <Box sx={{ mt: 4, mb: 4 }}>
                <Typography variant="body1" >
                    VENSYX Data Solutions helps you to meet the data management goals to
                    provide data assurance in terms of security, quality and accessibility.
                    VENSYX Data Solutions is focused on creation of accurate, consistent
                    and transparent data content for its customers. It emphasizes usability
                    of data for its intended purpose and audience. VENSYX Data Solutions
                    provides processes, tools, and metrics to help organizations use
                    information effectively and efficiently in order to achieve their
                    business objectives.
                </Typography>

                <Typography variant="body1" >
                    Companies today look at integrating and analyzing structured and
                    unstructured content across the enterprise. Our service offering in
                    Data Management enables customers to effectively manage volumes of data
                    and help convert information to insights. Our primary focus is on
                    helping our customers to build and maintain Master Data repositories,
                    tackle inconsistencies within their data, and cleanse and enrich it to
                    gain competitive benefits while simultaneously adhering to compliance
                    requirements.
                </Typography>
            </Box>

            <Typography variant="h6" gutterBottom sx={{ color: "#030366", fontWeight: "bold", }}>
                BI Data Management offerings at VENSYX Data Solutions:
            </Typography>

            <Grid container spacing={4} alignItems="center">
                <Grid item xs={12} md={6}>
                    <List>
                        {[
                            "Data Quality Management",
                            "Master Data Management",
                            "Meta – Data Management",
                            "Data Migration",
                            "Data Integration",
                            "Data Governance"
                        ].map((item) => (
                            <ListItem key={item} sx={{ pl: 0 }}>
                                <Typography variant="body1">{item}</Typography>
                            </ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Card sx={{ maxWidth: 400, mx: "auto" }}>
                        <CardMedia
                            component="img"
                            image="/images/dm.png"
                            alt="Data Management"
                        />
                    </Card>
                </Grid>
            </Grid>

            <Box sx={{ mt: 5 }}>
                <Typography variant="h5" gutterBottom sx={{ color: "#030366", fontWeight: "bold", }}>
                    Key Capabilities
                </Typography>

                {[
                    {
                        title: "Data Quality Management",
                        desc: "VENSYX Data Solutions specialists implement robust governance processes and assure quality via data de-duplication, data filtering, and error treatment across Telecom, Retail, Manufacture and Finance Services sectors."
                    },
                    {
                        title: "Master Data Management",
                        desc: "Our comprehensive MDM offerings optimize internal and external data management, and governance to help you make better-informed business decisions."
                    },
                    {
                        title: "Meta – Data Management",
                        desc: "Our metadata-driven development approach assigns a high priority to master data—the static core data at the heart of an organization—which encompasses information across the various units and teams in an organization."
                    },
                    {
                        title: "Data Migration",
                        desc: "VENSYX Data Solutions help enterprises to consolidate their data systems or migrate to a newer, more robust platform. We offer frameworks and solutions to mitigate associated risks while accelerating deployment."
                    },
                    {
                        title: "Data Integration",
                        desc: "Build an information-enabled enterprise by speedily transforming data into a key decision driver with VENSYX Data Solutions Data Transformation service. Our engineers leverage expertise in various ETL and ETL data transformation tools and operate across a variety of sectors."
                    },
                    {
                        title: "Data Governance",
                        desc: "VENSYX Data Solutions uses a high-performance data governance framework that embraces collaboration at all levels, we partner with you to drive business alignment, specialization, stewardship, responsibility, accountability, consistency, and scalability across the enterprise."
                    }
                ].map((item) => (
                    <Box key={item.title} sx={{ mt: 3 }}>
                        <Typography variant="h6" sx={{ color: "#030366", fontWeight: "500" }}>{item.title}</Typography>
                        <Typography variant="body1">{item.desc}</Typography>
                        <Divider sx={{ mt: 2, mb: 2, bgcolor: "grey.500" }} />
                    </Box>
                ))}
            </Box>

            <Box sx={{ mt: 5 }}>
                <Typography variant="h5" gutterBottom sx={{ color: "#030366", fontWeight: "bold" }}>
                    Business Value
                </Typography>
                <List>
                    {[
                        "Achieve organizational alignment on the governance of data management issues throughout the enterprise",
                        "Define and implement data architecture encompassing data modelling, data flow analysis, tuning, storage, visualization, and infrastructure",
                        "Identify, implement and maintain a single, unified view of reference data across the enterprise",
                        "Ensure data security, through security policies and processes",
                        "Establish processes that ensure good quality data on a regular and consistent basis"
                    ].map((item) => (
                        <ListItem key={item} sx={{ pl: 0 }}>
                            <Typography variant="body1">{item}</Typography>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Container >
    );
}

export default DataManagement;
